import { Dispatch } from 'architecture'
import React from 'react'

import _ from 'lodash'

import * as Rx from 'rxjs';
import { map, startWith } from 'rxjs/operators'

// import Inspector from '../components/app/inspector/Inspector'
// import HomeVideo from '../components/home/modules/Video'
// import Uploader from '../components/app/uploader/Uploader'

// const WrappedInspector = (props) => {
//   return (
//     <div 
//       className='vh-100 pt4 pb4 overflow-none'
//       onClick={e => props.Dispatch.nextAction('modal', 'close', '')
//       }>
//       <div
//         onClick={e => e.stopPropagation() 
//         }>
//         <Inspector {...props} />
//       </div>
//     </div>
//   )
// }

// const WrappedHomeVideo = (props) => {
//   return (
//     <div className='bg-black pa2-ns b--white ba br3-ns'>
//       <HomeVideo {...props} />
//     </div>
//   )
// }

const WrappedTagEditor = (props) => {
  return (
    <div className='mw4 bg-dark-gray pa2-ns b--moon-gray ba br1-ns white'>
      <div className='flex flex-column'>
        <div>Name</div>
        <div>Color</div>
      </div>
    </div>
  )
}

// const WrappedTagEditor = (props) => {
//   return (
//     <div 
//       className='vh-100 pt4 pb4 overflow-none'
//       onClick={e => props.Dispatch.nextAction('modal', 'close', '')
//       }>
//       <div
//         onClick={e => e.stopPropagation() 
//         }>
//         hiiiiiiiiiiii
//       </div>
//     </div>
//   )
// }

const components = {
  // Inspector: WrappedInspector,
  // HomeVideo: WrappedHomeVideo,
  // Uploader,
  TagEditor: WrappedTagEditor
}

const openModal$ = Dispatch.getAction('modal', 'open')
  .pipe(
    map(e => ({ isOpen: true, child: components[e] }))
  )

const closeModal$ = Dispatch.getAction('modal', 'close')
  .pipe(
    map(e => ({ isOpen: false })),
  )

Rx.merge(openModal$, closeModal$)
  .pipe(
    startWith({ isOpen: false })
  )
  .subscribe(e => Dispatch.nextState('modal', e ))
